import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import IndexDetailView from 'src/components/Dashboard/components/IndexDetailView';
import RejectedReferralsIndex from 'src/components/Dashboard/components/Referrals/RejectedReferralsIndex';
import { fetchDashboardReferrals } from 'actions/Referral/Group';
import _ from 'lodash';
import DetailView from 'src/components/Dashboard/components/DetailView';
import ReferralDetail from 'src/components/Referrals/ReferralDetail/index';
import fetchProvidersUserCore from 'src/actions/UserProvider/fetchProvidersUser';
import {
  noneAssignedOption,
  careCoordinatorFilterDefault,
} from 'src/components/Dashboard/utils/filterDefaults';
import FeatureFlagContainer from 'src/common/utils/FeatureFlags/FeatureFlagContainer';
import { getDataOfPage, isDataValid, getResponsePageMismatch } from 'src/components/Dashboard/utils/dataHelpers';
import appendReferralIdToLocation from 'src/components/Dashboard/utils/appendReferralIdToLocation';
import { goToReferral } from 'src/components/Referrals/utils/routing';
import { careCoordinatorsFilter, serviceTypesFilter } from 'src/components/Dashboard/utils/filter';
import { getGroupUsersOptions, getSentByOptions } from 'src/components/Groups/Users/utils';
import { crtb2646ShowProgramNameReferralsCasesDashboard } from 'src/common/utils/FeatureFlags/flags';
import labelCustomization from 'src/common/utils/Customization/labels';
import defaultLabels from 'src/constants/labels';
import { createSortChangeHandler } from 'src/components/Dashboard/utils/sortHelpers';
import { loadDashboardSortingConfiguration } from 'src/components/Dashboard/utils/userSortingHandler';
import { browserHistory } from 'common/utils/browserHistory';

export class RejectedReferrals extends Component {
  constructor(props) {
    super(props);
    this.onCellClick = this.onCellClick.bind(this);
    this.onFiltersChange = this.onFiltersChange.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.shouldFetch = this.shouldFetch.bind(this);
    this.fetch = this.fetch.bind(this);
    this.fetchGroupsUsers = this.fetchGroupsUsers.bind(this);
    this.fetchSentByUsers = this.fetchSentByUsers.bind(this);
    this.fetchRequestId = 0;
    const sortObj = loadDashboardSortingConfiguration(browserHistory.getCurrentLocation().pathname);

    this.state = {
      activeUsersInGroup: [],
      page: 1,
      sidx: sortObj?.column || 'updated_at',
      sord: sortObj?.sortDirection || 'desc',
      filters: {
        service_types: _.get(props, 'filters.service_types', []),
        care_coordinator_users: _.get(
          props,
          'filters.care_coordinator_users',
          careCoordinatorFilterDefault(props.userId, props.isCaseManager && props.isCC),
        ),
        referral_sender_users: props.isCaseManager ? ['all'] : [],
        referralState: 'declined',
        sent_by: _.get(
          props,
          'filters.sent_by',
          [props.currentEmployee.id],
        ),
      },
      employees: [],
    };
  }

  componentDidMount() {
    this.fetch();
    this.props.fetchProvidersUserCore({
      providers: this.props.groupId,
    }).then((response) => {
      if (response) {
        const { employees: activeUsersInGroup } = response;
        this.setState({ activeUsersInGroup, employees: response.employees });
      }
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.refetch && nextProps.refetch) {
      this.fetch(this.state.page);
    }
  }

  onCellClick(row) {
    const pagedData = getDataOfPage(this.props.rejectedReferrals, this.state.page);
    const referral = pagedData.data[row];

    goToReferral(referral);
  }

  onFiltersChange(key, activeFilters, callbacks) {
    let newFilters = activeFilters;
    if (_.isEqual(key, 'care_coordinator_users')) {
      newFilters = careCoordinatorsFilter(activeFilters, callbacks);
    }
    this.setState({
      page: 1,
      filters: _.assign({}, this.state.filters, { [key]: newFilters }),
    }, () => {
      this.fetch();
    });
  }

  onNextClick() {
    const page = this.state.page + 1;
    this.fetch(page);
  }

  onPrevClick() {
    const page = this.state.page - 1;
    this.fetch(page);
  }

  onSortChange = createSortChangeHandler(this);

  shouldFetch(page) {
    if (isDataValid(this.props.rejectedReferrals, page)) {
      this.setState({ page });
    } else {
      this.fetch(page);
    }
  }

  fetch(page = 1) {
    const requestId = this.fetchRequestId + 1;
    this.fetchRequestId = requestId;
    const formattedFilters = this.state.filters;
    formattedFilters.sent_by = _.uniq(
      _.map(formattedFilters.sent_by, (f) => f.split('-employee')[0]),
    );

    this.setState({ page });
    return Promise.resolve(this.props.fetchDashboardReferrals(
      this.props.groupId,
      'sent/rejected',
      {
        target: 'rejectedReferrals',
        sidx: this.state.sidx,
        sord: this.state.sord,
        filters: formattedFilters,
        page,
      },
      this.state.filters.referralState,
      null,
    )).then((response) => {
      if (requestId !== this.fetchRequestId) {
        return response;
      }

      const responsePage = getResponsePageMismatch(response, page);
      if (responsePage !== null) {
        this.setState({ page: responsePage });
      }

      return response;
    });
  }

  fetchGroupsUsers(search = '') {
    const { groupId } = this.props;
    return this.props.fetchProvidersUserCore({
      providers: groupId,
      options: {
        text: search,
        licensed: false,
      },
    }).then((response) => {
      if (response) {
        const { employees: activeUsersInGroup } = response;
        if (search === '') {
          return _.concat(
            [noneAssignedOption(this.state)],
            getGroupUsersOptions(activeUsersInGroup, this.state),
          );
        }

        return getGroupUsersOptions(activeUsersInGroup, this.state);
      }

      return [];
    });
  }

  fetchSentByUsers(search = '') {
    const { groupId, currentEmployee } = this.props;
    return this.props.fetchProvidersUserCore({
      providers: groupId,
      options: {
        licensed: false,
        text: search,
      },
    })
      .then((response) => {
        if (response) {
          return getSentByOptions(
            response.employees,
            this.state,
            currentEmployee,
          );
        }

        return [];
      });
  }

  render() {
    const {
      currentEmployee,
      rejectedReferrals,
      isFetching,
      isCC,
      baseLocation,
      params,
      serviceTypes,
      labels,
    } = this.props;
    const { activeUsersInGroup, employees } = this.state;
    const location = appendReferralIdToLocation(baseLocation, params);

    const filters = [
      serviceTypesFilter(serviceTypes, this.state.filters.service_types),
      {
        key: 'care_coordinator_users',
        name: labels.CareCoordinator,
        pluralName: `${labels.CareCoordinator}s`,
        options: _.concat(
          [noneAssignedOption(this.state.filters.care_coordinator_users)],
          getGroupUsersOptions(activeUsersInGroup, this.state),
        ),
      },
      {
        key: 'sent_by',
        name: 'Sent By',
        pluralName: 'Sent By',
        options: getSentByOptions(employees, this.state, currentEmployee),
        asyncSearch: this.fetchSentByUsers,
      },
    ];

    const innerContentView = (
      <ReferralDetail
        subjectType="referral"
        key={params.id}
        location={location}
        params={params}
        type="rejectedReferrals"
        showContactColumn

      />
    );

    const rejectedReferralDetailView = (
      <DetailView
        innerContentView={innerContentView}
      />
    );
    const pagedData = getDataOfPage(rejectedReferrals, this.state.page);

    return (
      <IndexDetailView
        params={this.props.params}
        DetailView={rejectedReferralDetailView}
        IndexView={RejectedReferralsIndex}
        data={pagedData.data}
        paging={pagedData.paging}
        isFetching={isFetching || pagedData.invalidated}
        onPrevClick={this.onPrevClick}
        onNextClick={this.onNextClick}
        onCellClick={this.onCellClick}
        initialSort={{ [this.state.sidx]: this.state.sord }}
        isCC={isCC}
        onFiltersChange={this.onFiltersChange}
        filters={_.sortBy(filters, 'name')}
        fetchGroupsUsers={this.fetchGroupsUsers}
        showProgramNameColumn={this.props.showProgramNameColumn}
        sortConfig={{ sidx: this.state.sidx, sord: this.state.sord }}
        setSort={this.onSortChange}
      />
    );
  }
}

RejectedReferrals.propTypes = {
  currentEmployee: PropTypes.object.isRequired,
  params: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  fetchDashboardReferrals: PropTypes.func.isRequired,
  rejectedReferrals: PropTypes.shape({
    data: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  userId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isCC: PropTypes.bool.isRequired,
  baseLocation: PropTypes.string.isRequired,
  serviceTypes: PropTypes.array.isRequired,
  fetchProvidersUserCore: PropTypes.func.isRequired,
  refetch: PropTypes.bool.isRequired,
  isCaseManager: PropTypes.bool.isRequired,
  labels: PropTypes.object,
  showProgramNameColumn: PropTypes.bool.isRequired,
};

RejectedReferrals.defaultProps = {
  labels: defaultLabels,
};

function mapStateToProps(state, ownProps) {
  const groupId = _.wget(state, 'session.groupId');
  return {
    currentEmployee: state.globalState.currentEmployee,
    baseLocation: ownProps.location.pathname,
    groupId,
    rejectedReferrals: _.get(state, 'dashboard.rejectedReferrals', {}),
    filters: _.get(state, 'dashboard.rejectedReferrals.filters', {}),
    isFetching: _.get(state, 'dashboard.rejectedReferrals.isFetching', false),
    isCC: _.wget(state, 'session.isCoordinationGroup', false),
    serviceTypes: _.wget(state, 'serviceTypes.allNetworks', []),
    refetch: _.get(state, 'dashboard.refetch'),
    userId: _.wget(state, 'user.id', null),
    token: _.get(state, 'session.token', ''),
    labels: labelCustomization(state),
    showProgramNameColumn: crtb2646ShowProgramNameReferralsCasesDashboard(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({ fetchDashboardReferrals, fetchProvidersUserCore }, dispatch),
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FeatureFlagContainer(RejectedReferrals));
